"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBreadCrumbChevronRight = function IconBreadCrumbChevronRight(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.7 3.4L6.3 6 3.7 8.6",
    stroke: color,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }));
};

IconBreadCrumbChevronRight.defaultProps = {
  color: 'black',
  size: 30
};
IconBreadCrumbChevronRight.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconBreadCrumbChevronRight;
exports.default = _default;